import { Player } from '@/API';
import { usePlayer } from '@/hooks/PlayerSessionControlHooks';
import React from 'react';
import PlayerDrawingCards from './DrawingCards';
import FeelingAfter from './FeelingAfter';
import PlayerQuestion from './Question';

const ScreenComponent = React.memo(({ player }: { player: Player }) => {
  if (!player.feelingAfter) {
    return <FeelingAfter />;
  }

  if (!player.question && !player.questionAnswer) {
    return <PlayerQuestion />;
  }

  return <PlayerDrawingCards />;
});

ScreenComponent.displayName = 'ScreenComponent';

export default function PlayerEndGame() {
  const player = usePlayer();

  return (
    <div className="flex flex-col justify-between items-center h-full">
      <div className="flex flex-col justify-center items-center h-[calc(100%-116px)]">
        {player && <ScreenComponent player={player} />}
      </div>
    </div>
  );
}
